<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select v-model="listQuery.tenantId" placeholder="选择租户" clearable clearable style="width: 200px" class="filter-item" @change="handleTenantChange" @clear="handleTenantClear">
        <el-option v-for="item in tenantList" :key="item.tenantId" :label="item.name" :value="item.tenantId" />
      </el-select>
      <el-input v-model="listQuery.convNo" placeholder="会话编号" clearable style="width: 200px;" class="filter-item" @keyup.enter.native="handleFilter" />
      <el-select v-model="listQuery.status" placeholder="状态" clearable clearable style="width: 150px" class="filter-item">
        <el-option label="排队中" value="pending" />
        <el-option label="进行中" value="active" />
        <el-option label="已结束" value="closed" />
      </el-select>
      <el-select v-model="listQuery.agentId" placeholder="客服" clearable style="width: 150px" class="filter-item">
        <el-option v-for="item in filteredAgentList" :key="item.agentId" :label="item.displayName || item.agentName" :value="item.agentId" />
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="会话ID" prop="conversationId" align="center" width="80" />
      <el-table-column label="会话编号" prop="convNo" align="center" width="250" />
      <el-table-column label="租户" prop="tenantName" align="center" width="150" />
      <el-table-column label="用户" align="center" width="180">
        <template slot-scope="{row}">
          <div v-if="row.userOpenId || row.userNickname">
            <div v-if="row.userNickname">{{ row.userNickname }}</div>
            <div v-if="row.userOpenId" style="color: #909399; font-size: 12px;">{{ row.userOpenId }}</div>
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="客服" align="center" width="180">
        <template slot-scope="{row}">
          <span>{{ row.agentLoginCode || row.agentName || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" align="center" width="100">
        <template slot-scope="{row}">
          <el-tag :type="row.status | statusFilter">{{ row.status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="评分" prop="rating" align="center" width="80" />
      <el-table-column label="消息数" prop="totalMessageCount" align="center" width="80" />
      <el-table-column label="创建时间" prop="createdAt" align="center" width="160">
        <template slot-scope="{row}">
          <span>{{ row.createdAt | parseTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="{row}">
          <el-button type="primary" size="mini" @click="handleDetail(row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize" @pagination="getList" />

    <el-dialog :title="'会话详情 - ' + (currentConversation.convNo || '') + '（' + (currentConversation.tenantName || '') + '）'" :visible.sync="dialogVisible" width="800px" top="5vh">
      <div v-loading="detailLoading">
        <el-descriptions :column="2" border style="margin-bottom: 20px;">
          <el-descriptions-item label="会话编号">{{ currentConversation.convNo }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="currentConversation.status | statusFilter">{{ currentConversation.status }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="用户昵称">{{ currentConversation.userNickname || '-' }}</el-descriptions-item>
          <el-descriptions-item label="用户OpenID">{{ currentConversation.userOpenId || '-' }}</el-descriptions-item>
          <el-descriptions-item label="客服">{{ currentConversation.agentName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="评分">{{ currentConversation.rating || '-' }}</el-descriptions-item>
          <el-descriptions-item label="消息数">{{ currentConversation.totalMessageCount || 0 }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ currentConversation.createdAt | parseTime }}</el-descriptions-item>
        </el-descriptions>

        <div class="messages-title">消息记录</div>
        <div class="messages-container">
          <div v-if="messages.length === 0" class="empty-message">
            <el-empty description="暂无消息记录" />
          </div>
          <div v-else class="message-list">
            <div v-for="msg in messages" :key="msg.messageId" class="message-item" :class="msg.senderType">
              <div class="message-avatar">
                <el-avatar :src="msg.senderAvatar || (msg.senderType === 'agent' ? '/default-agent-avatar.png' : '/default-user-avatar.png')" size="small" />
              </div>
              <div class="message-content">
                <div class="message-header">
                  <span class="sender-name">{{ msg.senderName || (msg.senderType === 'agent' ? '客服' : '用户') }}</span>
                  <span class="message-time">{{ msg.createdAt | parseTime }}</span>
                </div>
                <div class="message-body">
                  <div v-if="msg.contentType === 'text'" class="text-message" v-html="renderContent(msg.content)"></div>
                  <div v-else-if="msg.contentType === 'image'" class="image-message">
                    <el-image :src="msg.content" :preview-src-list="[msg.content]" style="max-width: 150px; max-height: 150px" />
                  </div>
                  <div v-else-if="msg.contentType === 'file'" class="file-message">
                    <el-link :href="msg.content" target="_blank" type="primary">
                      <i class="el-icon-document" /> {{ msg.fileName || '下载文件' }}
                    </el-link>
                  </div>
                  <div v-else class="text-message" v-html="renderContent(msg.content)"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-pagination">
          <el-pagination
            :current-page="msgQuery.pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="msgQuery.pageSize"
            :total="msgTotal"
            layout="total, sizes, prev, pager, next"
            @size-change="handleMsgSizeChange"
            @current-change="handleMsgPageChange"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listConversations, getConversation, getConversationMessages } from '@/api/conversation'
import { listTenants } from '@/api/tenant'
import { listAgents } from '@/api/agent'
import Pagination from '@/components/Pagination'

export default {
  name: 'ConversationList',
  components: { Pagination },
  filters: {
    statusFilter(status) {
      const statusMap = {
        ended: 'danger',
        pending: 'danger',
        active: 'success',
        closed: 'info'
      }
      return statusMap[status]
    },
    parseTime(time) {
      if (!time) return ''
      const date = new Date(time)
      return date.toLocaleString()
    }
  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      tenantList: [],
      agentList: [],
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        tenantId: undefined,
        convNo: undefined,
        status: undefined,
        agentId: undefined
      },
      dialogVisible: false,
      detailLoading: false,
      currentConversation: {},
      currentConversationId: null,
      messages: [],
      msgTotal: 0,
      msgQuery: {
        pageNum: 1,
        pageSize: 20
      }
    }
  },
  created() {
    this.getTenantList()
    this.getAgentList()
    this.getList()
  },
  computed: {
    filteredAgentList() {
      if (!this.listQuery.tenantId) {
        return this.agentList
      }
      return this.agentList.filter(agent => agent.tenantId === this.listQuery.tenantId)
    }
  },
  methods: {
    getTenantList() {
      listTenants({ pageNum: 1, pageSize: 1000 }).then(response => {
        this.tenantList = response.data.records || []
      })
    },
    getAgentList() {
      listAgents({ pageNum: 1, pageSize: 1000 }).then(response => {
        this.agentList = response.data.records || []
      })
    },
    getList() {
      this.listLoading = true
      listConversations(this.listQuery).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.pageNum = 1
      this.getList()
    },
    handleTenantChange() {
      this.listQuery.agentId = undefined
    },
    handleTenantClear() {
      this.listQuery.tenantId = undefined
      this.listQuery.agentId = undefined
    },
    handleDetail(row) {
      this.dialogVisible = true
      this.detailLoading = true
      this.currentConversation = {}
      this.messages = []
      this.msgQuery.pageNum = 1
      this.currentConversationId = row.conversationId
      
      getConversation(row.conversationId).then(res => {
        this.currentConversation = res.data || {}
      })
      
      this.getMessages()
    },
    getMessages() {
      this.detailLoading = true
      getConversationMessages(this.currentConversationId, {
        pageNum: this.msgQuery.pageNum,
        pageSize: this.msgQuery.pageSize
      }).then(res => {
        this.messages = res.data.records || []
        this.msgTotal = res.data.total || 0
        this.detailLoading = false
      }).catch(() => {
        this.detailLoading = false
      })
    },
    handleMsgSizeChange(val) {
      this.msgQuery.pageSize = val
      this.msgQuery.pageNum = 1
      this.getMessages()
    },
    handleMsgPageChange(val) {
      this.msgQuery.pageNum = val
      this.getMessages()
    },
    renderContent(content) {
      if (!content) return ''
      const emojiPattern = /\[em:(\d+)\]/g
      return content.replace(emojiPattern, (match, index) => {
        return `<img src="/em_${index}.png" class="emoji-img" alt="${match}" />`
      })
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
.filter-item {
  margin-right: 10px;
}
.messages-title {
  font-weight: bold;
  margin-bottom: 10px;
  padding-left: 5px;
  border-left: 3px solid #409EFF;
}
.messages-container {
  min-height: 300px;
  max-height: 50vh;
  overflow-y: auto;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
}
.empty-message {
  padding: 30px 0;
}
.message-list {
  display: flex;
  flex-direction: column;
}
.message-item {
  display: flex;
  margin-bottom: 15px;
}
.message-item.user {
  flex-direction: row;
}
.message-item.agent {
  flex-direction: row-reverse;
}
.message-avatar {
  flex-shrink: 0;
}
.message-content {
  max-width: 70%;
  margin: 0 10px;
}
.message-header {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.message-item.agent .message-header {
  flex-direction: row-reverse;
}
.sender-name {
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
}
.message-time {
  font-size: 12px;
  color: #c0c4cc;
}
.message-body {
  padding: 8px 12px;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.message-item.user .message-body {
  background: #e6f7ff;
}
.message-item.agent .message-body {
  background: #f0f9eb;
}
.text-message {
  word-break: break-word;
  line-height: 1.5;
  font-size: 14px;
}
.image-message {
  overflow: hidden;
}
.file-message {
  padding: 3px 0;
}
.emoji-img {
  width: 20px !important;
  height: 20px !important;
  vertical-align: middle;
  display: inline-block;
}
::v-deep .emoji-img {
  width: 20px !important;
  height: 20px !important;
  vertical-align: middle;
  display: inline-block;
}
.dialog-pagination {
  margin-top: 15px;
  text-align: right;
}
</style>
